"use client";

import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MapAndDetails() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const contactDetails = [{
    icon: Phone,
    label: "Phone",
    value: "254.299.3608",
    href: "tel:(Your Phone Number Here)"
  }, {
    icon: Mail,
    label: "Email",
    value: "Mark.Taylor@centexdrone.com",
    href: "mailto:info@aeromap.com"
  }, {
    icon: MapPin,
    label: "Service Area",
    value: "Central Texas & DFW Metroplex",
    href: null
  }, {
    icon: Clock,
    label: "Hours",
    value: "Monday - Friday: 8am - 6pm",
    subValue: "Nighttime operations available by appointment",
    href: null
  }];
  return <section className="relative w-full h-[600px] overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1520322/img/central_texas_dfwmap_satellite.png)] bg-cover bg-center" />
      
      {}
      <div className="absolute inset-0 bg-dark-background/40" />

      {}
      <div className="relative z-10 flex items-center justify-center h-full px-4 py-12">
        <div ref={ref} className={`w-full max-w-4xl transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Card className="glass-effect hover-lift bg-background/90 backdrop-blur-md shadow-strong">
            <CardContent className="p-8 md:p-12">
              <div className="text-center mb-8">
                <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-3">
                  Contact MT4 Drones Services
                </h2>
                <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                  Serving Central Texas and the DFW Metroplex with precision aerial services
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {contactDetails.map((detail, i) => {
                const Icon = detail.icon;
                const content = <div data-index={i} className="flex items-start gap-4 p-4 rounded-lg bg-muted/30 hover:bg-muted/50 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1">
                      <div className="flex-shrink-0 w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                        <Icon className="w-6 h-6 text-primary" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-semibold text-muted-foreground mb-1">
                          {detail.label}
                        </p>
                        <p className="text-base font-medium text-foreground break-words">
                          {detail.value}
                        </p>
                        {detail.subValue && <p className="text-sm text-muted-foreground mt-1">
                            {detail.subValue}
                          </p>}
                      </div>
                    </div>;
                return detail.href ? <Link key={i} to={detail.href} className="focus-ring rounded-lg block">
                      {content}
                    </Link> : <div key={i}>
                      {content}
                    </div>;
              })}
              </div>

              <div className="mt-8 pt-8 border-t border-border text-center">
                <p className="text-sm text-muted-foreground">Up to $1 million liability insurance | State-of-the-art DJI Matrice 4T drone</p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}